import { Content } from "antd/es/layout/layout";
import { ConversationHeader } from "./Header.conversations";
import { useState } from "react";
import ConversationList from "./conversations.list";

const ConversationContainer = ({
  setIsNewConversation,
  setParticipants
}: {
  setIsNewConversation: Function;
  setParticipants: Function;
}) => {

  const [convsersationsFilter, setConversationsFilter] = useState<{
    unread: boolean;
    assigned: boolean;
    unresolved: boolean;
    resolved: boolean;
    unassigned: boolean;
    assigned_user: string
  }>({
    unread: false,
    assigned: false,
    unresolved: false,
    resolved: false,
    unassigned: false,
    assigned_user: "",
  });

  const ContainerContentStyle: React.CSSProperties = {
    height: "100%",
    borderRight: "1px solid rgb(223, 226, 232)",
  };

  return (
    <Content style={ContainerContentStyle}>
      <ConversationHeader
        setConversationsFilter={setConversationsFilter}
        convsersationsFilter={convsersationsFilter}
        setParticipants={setParticipants}
        setIsNewConversation={setIsNewConversation}
      />
      <ConversationList
        key={"conversation-list"}
        setIsNewConversation={setIsNewConversation}
        convsersationsFilter={convsersationsFilter}
      />
    </Content>
  );
};

export default ConversationContainer;
